export const VISIBLE = 0;
export const EDITABLE = 1;
export const READONLY = 2;
export const HIDDEN = 3;